'use client';

import { useOptionalRenderContext } from './RenderContextProvider';

interface TextProps {
  children: string | undefined | null;
  className?: string;
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  /** Strapi field name — sets `data-strapi-field` for inline-edit overlays. */
  field?: string;
}

// Concept §6.5 widget API: plain-string fields go through this helper so
// placeholder + glossary substitution runs uniformly. Widgets call
// `<Text field="title">{config.title}</Text>` instead of inlining the string.
export function Text({
  children,
  className,
  as: Tag = 'span',
  field,
}: TextProps) {
  const ctx = useOptionalRenderContext();
  if (children == null) {
    return null;
  }
  const value = ctx ? ctx.substitutePlaceholders(children) : children;
  return (
    <Tag
      className={className}
      data-strapi-field={field}
      data-strapi-field-raw={field ? children : undefined}
    >
      {value}
    </Tag>
  );
}
